// extracted by mini-css-extract-plugin
module.exports = {"toast":"BuyFormConnectWalletToast_toast__1tw4A","toastBtn":"BuyFormConnectWalletToast_toastBtn__1XpUk","toastContent":"BuyFormConnectWalletToast_toastContent__fbdxi"};